import React from 'react';
import { Row, Col, Typography, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import CompanyDataCard from '../../../components/reusable/CompanyDataCard';

const { Title } = Typography;

const CompanyDataBlock = ({ companyData = {}, hasBackBtn = false, onBackBtnClick = () => {}, enablePdf }) => {
  const { t } = useTranslation();
  const { creditInfoId, name, code, status, address, nace2, nace2Code, isAfterBankruptcy } = companyData;

  const CompanyDataRow = ({ type, value }) => (
    <Row>
      <Col xs={24} xl={10}>
        <strong>{type}</strong>
      </Col>
      <Col xs={24} xl={14}>
        {value}
      </Col>
    </Row>
  );

  return (
    <CompanyDataCard title={!enablePdf && <div style={{ fontSize: 20, color: '#C40F11' }}> {name} </div>} alignTextLeft>
      <Row className="statistic-block statistic-block--company" gutter={[8, 8]}>
        <Col xs={24} sm={12}>
          <CompanyDataRow key={creditInfoId} type={t('companySearch.results.basic.ciid')} value={creditInfoId} />
          <CompanyDataRow key={name} type={t('companySearch.results.basic.companyName')} value={name} />
          <CompanyDataRow key={code} type={t('companySearch.results.basic.code')} value={code} />
        </Col>
        <Col xs={24} sm={12}>
          <CompanyDataRow
            key={status}
            type={t('companySearch.results.basic.status')}
            value={
              isAfterBankruptcy ? (
                `${status} ${t('companyBasicInformation.basicData.basicInformation.isAfterBankruptcy')}`
              ) : (
                <strong
                  className={
                    status === 'Veikiantis subjektas' || status === 'Active subject'
                      ? 'color-success'
                      : 'color-secondary'
                  }
                >
                  {status}
                </strong>
              )
            }
          />
          <CompanyDataRow key={address} type={t('companySearch.results.basic.address')} value={address} />
          <CompanyDataRow
            key={nace2}
            type={t('companySearch.results.basic.tradeSector')}
            value={`${nace2Code} - ${nace2}`}
          />
        </Col>
      </Row>
    </CompanyDataCard>
  );
};

export default CompanyDataBlock;
